import type { QuotationChargingItemVO } from '@/api/quotation/quotation-base'

type QuotationChargeRecord = {
  chargingItemList?: QuotationChargingItemVO[] | null
  chargingItems?: QuotationChargingItemVO[] | null
}

export function listQuotationChargingItems(record?: QuotationChargeRecord | null): QuotationChargingItemVO[] {
  if (!record) return []
  const items = record.chargingItemList || record.chargingItems || []
  return items.filter(item => item && typeof item === 'object')
}

export function formatQuotationAmount(value: unknown, currency?: unknown): string {
  if (value === null || value === undefined || value === '') return '-'
  const num = Number(value)
  const amount = Number.isFinite(num)
    ? num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : String(value)
  const code = String(currency || '').trim()
  return code ? `${amount} ${code}` : amount
}

export function formatQuotationDateRange(from?: string | null, to?: string | null): string {
  const start = String(from || '').split(' ')[0]
  const end = String(to || '').split(' ')[0]
  if (!start && !end) return '-'
  return `${start || '-'} ~ ${end || '-'}`
}
